import api from './api';

export const checkApiStatus = async (): Promise<boolean> => {
  try {
    const response = await api.get('/health');
    return response.status === 200;
  } catch (error) {
    return false;
  }
};

export const checkDbStatus = async (): Promise<boolean> => {
  try {
    const response = await api.get('/health');
    return response.data.db === 'ok';
  } catch (error) {
    return false;
  }
};
